import { Component, OnInit } from '@angular/core';

import { Loading } from 'src/shared/components/loading/loading';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';

@Component({
    templateUrl: 'active-integrations.html',
    standalone: false
})

export class ActiveIntegrationsPage implements OnInit {

  addresses: any;
  dialogParams: any;
  isRightSideContent: boolean;
  loaded: boolean;
  remoteAccessAddresses: any;
  webhooks: any;
  shownActiveIntegrations: any;
  activeIntegrations: any;

  constructor(
    private navCtrl: CustomNavController,
    private storage: TidyStorage,
    private rightSidePanelService: RightSidePanelService,
  ) {}

  @Loading('', true)
  async ngOnInit() {
    try {
      this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
      if (this.isRightSideContent) {
        this.dialogParams = await this.storage.retrieve('dialog-params');
        this.rightSidePanelService.setDialogPageTitle('Active Integrations');
      } else {
        // On mobile this page is reached via navigateForward, so the params
        // (including addresses) live in history.state, not the 'dialog-params'
        // storage key used by the desktop right-side panel.
        this.dialogParams = this.navCtrl.getParams(false);
      }
      this.loaded = true;
    } catch (_err) {
      // Silent error handling
    }
  }

}
